module.exports = __webpack_public_path__ + "static/img/1021.44e728b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1021.jpg
// module id = 203
// module chunks = 0